import { Box, Flex, Heading, Icon, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";

import { Button } from "../../../../components";
import { MaterialInputMethodSelector } from "./MaterialInputMethodSelector";
import { type MaterialInput } from "./types";

type FlexIntakeJdSubStepProps = {
  onBack: () => void;
  onSubmit: () => void;
  loading?: boolean;
  isAtsConnected?: boolean;
  isValid?: boolean;
  value: MaterialInput;
  onChange: (state: MaterialInput) => void;
};

export const FlexIntakeJdSubStep: React.FC<FlexIntakeJdSubStepProps> = ({
  onBack,
  onSubmit,
  loading = false,
  isAtsConnected = false,
  isValid = false,
  value,
  onChange,
}) => (
  <Box w="100%" overflow="auto">
    <Flex
      direction="column"
      align="center"
      maxWidth="692px"
      p="12"
      mx="auto"
      gap="8"
      borderRadius="2xl"
      boxShadow="base"
      border="1px solid"
      borderColor="blue.200"
      bg="white"
    >
      <VStack align="flex-start" spacing="2" w="100%">
        <Flex align="center" gap="2">
          <Icon as={HiOutlineWrenchScrewdriver} boxSize="6" color="gray.600" />
          <Heading
            fontSize="2xl"
            fontWeight="medium"
            color="gray.800"
            lineHeight="short"
          >
            Job description
          </Heading>
        </Flex>
        <Text fontSize="sm" color="gray.500" lineHeight="base">
          A JD will help generate a tailored interview guide and suggestions.
        </Text>
      </VStack>

      <MaterialInputMethodSelector
        isAtsConnected={isAtsConnected}
        value={value}
        onChange={onChange}
        label="How would you like to add your job description?"
        textareaMinHeight="175px"
      />

      <Flex w="100%" justify="space-between" align="center">
        <Button variant="link" colorScheme="blue" onClick={onBack}>
          Back
        </Button>
        <Button
          colorScheme="blue"
          onClick={onSubmit}
          isLoading={loading}
          isDisabled={!isValid}
        >
          Next: Train Interviewer
        </Button>
      </Flex>
    </Flex>
  </Box>
);
